export default __webpack_public_path__ + "static/media/icon-music.f20c7787.svg";